import React from 'react';
import { Grid, TextField } from '@material-ui/core';

type columnCount = boolean | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;

interface IGridTextFieldProps {
  label: string,
  xs?: columnCount,
  sm?: columnCount,
  md?: columnCount,
  lg?: columnCount,
  xl?: columnCount,
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  value?: any,
  readOnly?: any,
  required?: boolean,
  maxLength?: number,
  error?: boolean
}

const GridTextField: React.FC<IGridTextFieldProps> = props => {
    const { label, onChange, value, xs, sm, md, lg, xl, required, readOnly, maxLength, error } = props;

  return (
    <Grid
      item={true}
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
    >
      <TextField
        label={label}
        fullWidth={true}
        onChange={onChange}
        value={value}
        InputProps={{
            readOnly: readOnly,
        }}
        inputProps={{
          maxLength
        }}
        required={required}
        error={error}
      />
    </Grid>
  );
};

export default GridTextField;
